import { FETCH_WELLNESS_GOAL, FETCH_WELLNESS_GOAL_FAIL, FETCH_WELLNESS_GOAL_SUCCESS } from 'actions/wellnessGoals';

const INITIAL_STATE = {
    goals: {},
    isFetching: {},
    didFetchFail: false
};

// ======= Fetching Handlers =======
const fetchGoalFetching = (state, action) => {
    return {
        goals: { ...state.goals },
        isFetching: { [action.userGoalType]: true },
        didFetchFail: { [action.userGoalType]: false }
    };
};

const fetchGoalSuccess = (state, action) => {
    return {
        goals: { ...state.goals, [action.userGoalType]: action.data },
        isFetching: { [action.userGoalType]: false },
        didFetchFail: { [action.userGoalType]: false }
    };
};

const fetchGoalFail = (state, action) => {
    delete state.goals[action.userGoalType];
    return {
        goals: { ...state.goals },
        isFetching: { [action.userGoalType]: false },
        didFetchFail: { [action.userGoalType]: true }
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_WELLNESS_GOAL]: fetchGoalFetching,
    [FETCH_WELLNESS_GOAL_SUCCESS]: fetchGoalSuccess,
    [FETCH_WELLNESS_GOAL_FAIL]: fetchGoalFail
};

// ======= Default Action =======
export default function wellnessGoal(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchWellnessGoal(userGoalType, trackingPeriodType, evictCache) {
    return {
        type: FETCH_WELLNESS_GOAL,
        trackingPeriodType: trackingPeriodType,
        userGoalType: userGoalType,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getWellnessGoal = (state, userGoalType) => {
    return state.wellnessGoal.goals[userGoalType];
};

export const isWellnessGoalFetching = (state, userGoalType) => {
    return state.wellnessGoal.isFetching[userGoalType];
};
